<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-spinner"></div>
  </div>
</template>
 
<script>
export default {
  name: 'Loading',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
 
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(255, 255, 255, 0.8); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保在页面其他内容之上 */
}
 
.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* 灰色外圈 */
  border-left-color: #0256FF; /* 蓝色加载条 */
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1s linear infinite; /* 应用动画 */
}
 
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>